import React from "react";
import styles from "./styles.module.scss";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { customTooltip } from "../../helpers";

export const SubscribersBarChart = ({
  aggregatedMonthsData,
  height,
  maxValue,
}) => {
  return (
    <div>
      <ResponsiveContainer width="100%" height={height - 65}>
        <BarChart
          width={500}
          height={height - 65}
          data={aggregatedMonthsData}
          barSize={8}
          maxBarSize={8}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          {/* background: linear-gradient(180deg, rgba(20, 163, 99, 0.8) 12.86%, rgba(7, 61, 37, 0.8) 91.9%); */}

          <defs>
            <linearGradient id="golfGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#B1E3FF" stopOpacity={1} />
              <stop offset="100%" stopColor="#6A8899" stopOpacity={1} />
            </linearGradient>
            <linearGradient id="baseballGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#FBB900" stopOpacity={1} />
              <stop offset="100%" stopColor="#956E00" stopOpacity={1} />
            </linearGradient>
            <linearGradient id="athleticsGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#14A363" stopOpacity={0.8} />
              <stop offset="100%" stopColor="#073D25" stopOpacity={0.8} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="1 1" vertical={false} />
          <XAxis dataKey="name" />
          <YAxis domain={[0, maxValue]} />
          <Tooltip shared={false} content={customTooltip(styles)} />
          <Bar
            dataKey="golf.combined"
            fill="url(#golfGradient)"
            radius={[10, 10, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
